"use strict";import{TableBody as e}from"./src/TableBody.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-table-body",e);
//# sourceMappingURL=sp-table-body.js.map
